import { environment } from 'src/environments/environment';
export const UrlConstantes = {

  login: environment.apiUrl + 'login',
  validaCredenciales: environment.apiUrl + 'validaCredenciales',
  getMenu: environment.apiUrl + 'menu/findMenuByIdPerfil',

  validaSession: environment.apiUrl + 'validarSession',

  cerrarSession: environment.apiUrl + 'cerrarSession',

  getMenusPorPerfil: environment.apiUrl + 'menu/findMenuByPerfil/',
  getMenus: environment.apiUrl + 'menu',


  consultaEmpleados: environment.apiUrl + "consultaEmpleados.do",

  consultaCantidadEmpleados: environment.apiUrl + "empleado/consultaNumEmpleados.do",
  guardaActualizaEmpleado: environment.apiUrl + "empleado/guardaActualizaEmpleado.do",
  consultaPuestosArea: environment.apiUrl + 'empleado/consultaPuestosXArea.do',
  consultaAreasEmpresa: environment.apiUrl + 'empleado/consultaAreasXEmpresa.do',
  consultarPerfilEmpleados: environment.apiUrl + 'empleado/buscaPerfilesEmpleados.do',
  consultaPerfiles: environment.apiUrl + 'empleado/buscaPerfiles.do',
  consultaEmpleadosPrincipal: 'empleado/paginadoPrincipalEmpleado.do',
  buscarUsuario: environment.apiUrl + 'empleado/buscaUsuario.do',

  recuperaPass: 'restaurarPass.do',
  actualizaPassword: 'actualizaPass.do',


  //Perfiles
  consultaCantidadPerfiles: environment.apiUrl + 'buscaNumeroPerfiles.do',
  consultarPerfil: environment.apiUrl + 'buscaPerfilesPaginacion.do',
  ConsultaMenus: environment.apiUrl + 'buscaMenus.do',
  GuardaPerfil: environment.apiUrl + 'guardaOrModificaPerf.do',
  ConsulXUpdatePerfil: environment.apiUrl + 'consultaUnSoloPerfilUpdate.do',
  ConsulXUpdateMenu: environment.apiUrl + 'consultaMenusIdPerfil.do',
  InsertaCorporativo: environment.apiUrl + 'controller/pruebaS.do',
  consultaPerfilAll: 'consultaPerfilAll.do',
  //Areas
  consultaAreaPaginacion: environment.apiUrl + 'consultarAreaPaginacion.do',
  consultaPuestoPorAreaPaginacion: environment.apiUrl + 'area/consultaPuestoxAreaPaginacion.do',
  guardarArea: environment.apiUrl + 'area/guardaArea.do',
  consultaAreaAll: 'area/consultaAreaAll.do',

  //Tipo de inmueble
  consultaTipoInmuebles: environment.apiUrl + 'inmuebles/consultaTipoInmuebles.do',
  consultaInmueblesPaginacion: environment.apiUrl + 'inmuebles/consultaInmueblesPaginacion.do',
  GuardaInmueble: environment.apiUrl + 'inmuebles/guardaInmueble.do',
  ConsulXUpdateInmueble: environment.apiUrl + 'inmuebles/ConsulXUpdateInmueble.do',
  consultaInmueblesAll: 'inmuebles/consultaInmueblesAll.do',

  TIPOS_GARANTIAS_PAGINADO: "tiposGarantias/paginadoPrincipal",
  GARANTIAS_PAGINADO: "garantias/paginadoPrincipal",

  CONSULTA_PLAZOS_CREDITO: 'plazo/paginadoPrincipalPlazo',
  FINANCIERA: 'financiera',
  //Garantias
  TIPOS_GARANTIAS: "tiposGarantias",

  // Fondos
  consultaFondoPaginacion: environment.apiUrl + 'fondo/consultarFondoPaginacion.do',
  guardarFondo: environment.apiUrl + 'fondo/guardaFondo.do',
  consultaFinanciera: environment.apiUrl + 'consultarFinanciera.do',
  consultaFondoAll: 'fondo/consultaFondoAll.do',

  //Configuracion General
  DELETE_CONFIG: environment.apiUrl + 'DeleteConfig.do',
  SAVEUPDATE_CONFIG: environment.apiUrl + 'saveOrUpdateConfig.do',
  ESCANER_URL: environment.apiUrl + "consultaEscanner.do",
  BUSCA_CONFIG: environment.apiUrl + 'buscaConfiguraciones.do',
  BUSCAGEN_CONFIG: environment.apiUrl + 'buscaConfigGen.do',

  //Destino de Credito
  consultarDestinoCreditoPaginacion: environment.apiUrl + 'consultarDestinoCreditoPaginacion.do',
  guardaActualizaDestino: environment.apiUrl + 'guardaActualizaDestino.do',
  consultarDestinoCreditoTodos: environment.apiUrl + 'obtenerListaCreditos.do',
  consultaDestinoAll: 'consultaDestinoAll.do',

  //Tipos de Domicilio
  guardarDomicilio: environment.apiUrl + 'guardarDomicilio.do',
  consultaDomicilioPaginacion: environment.apiUrl + 'consultaDomicilioPaginacion.do',
  ConsulXUpdateDomicilio: environment.apiUrl + 'ConsulXUpdateDomicilio.do',
  consultaDomicilioAll: 'consultaDomicilioAll.do',

  //Identificacion
  consultaIdentificacionPaginacion: environment.apiUrl + "tipoIdentificacion/consultaIdentificacionPaginacion.do",
  guardarIdentificacion: environment.apiUrl + "tipoIdentificacion/guardarIdentificacion.do",
  ConsulXUpdateIdentificacion: environment.apiUrl + "tipoIdentificacion/ConsulXUpdateIdentificacion.do",
  consultaIdentificacionAll: "tipoIdentificacion/consultaIdentificacionAll.do",


  //Sucursales
  ConsultarSucursalesPaginacion: environment.apiUrl + 'sucursal/consultarSucursalesPaginacion.do',
  guardaActualizaSucursal: environment.apiUrl + "sucursal/guardaActualizaSucursal.do",
  consultaExistenciaMatriz: environment.apiUrl + "sucursal/consultaExistenciaMatriz.do",
  consultaSucursalesPrincipal: 'sucursal/paginadoPrincipalSucursal.do',

  //Direccion
  iniciaCargaInicial: environment.apiUrl + 'cargaInicial.do',
  consultaDistEstados: environment.apiUrl + 'consultaDistintosEstados.do',
  consultaPorCodigoPostal: environment.apiUrl + 'consultaPorCodigoPostal.do',
  consultaPorEstado: environment.apiUrl + 'consultaPorEstado.do',
  consultaPorEstadoYMunicipio: environment.apiUrl + 'consultaPorEstadoAndMunicipio.do',
  ConsultaPorEstadoMunicipioCiudad: environment.apiUrl + 'consultaPorEstadoAndMunicipioAndCiudad.do',
  consultaDistTiposAsentamiento: environment.apiUrl + 'consultaDistintosTiposDeAsentamiento.do',
  ConsultaPorEstadoMunicipioCiudadTipoAsent: environment.apiUrl + 'consultaPorEstadoAndMunicipioAndCiudadTipoAsent.do',
  // Tipo Creditos
  //consultarTipoCreditosPaginacion: environment.apiUrl + 'consultarTipoCreditosPaginacion.do',
  guardaActualizaCreditos: environment.apiUrl + 'tipoCredito/guardaActualizaCreditos.do',
  consultaFinancieraCreditos: environment.apiUrl + 'consultarFinancieraCreditos.do',
  consultaTipoCreditos: 'tipoCredito/paginadoPrincipalTipoCredito.do',

  //Giro Mercantil
  consultaGiroMercantilPaginacion: environment.apiUrl + 'consultarGiroMercantilPaginacion.do',
  consultaPersonalidad: environment.apiUrl + 'giroMercantil/consultarPersonalidad.do',
  guardaActualizaMercantil: environment.apiUrl + 'giroMercantil/guardaActualizaMercantil.do',
  consultarGiroMercantilPersonalidadPaginacion: environment.apiUrl + 'consultarGiroMercantilPersonalidadPaginacion.do',
  tipoPersonalidad: environment.apiUrl + 'consultarPersonalidad.do',
  consultaGiroMercantil: 'giroMercantil/paginadoPrincipalGiroMercantil.do',
  consultaPersona: '',

  //Bancos
  consultarBancoPaginacion: environment.apiUrl + 'consultarBancoPaginacion.do',
  guardaActualizaBanco: environment.apiUrl + 'banco/guardaActualizaBanco.do',
  consultaBancos: 'banco/paginadoPrincipalBanco.do',

  //DatosUsuario
  consultarUsuario: environment.apiUrl + 'usuarios/consultaUsuario.do',
  guardaActualizaUsuario: environment.apiUrl + 'empleado/guardaActualizaUsuario.do',
  fotoPersona: environment.apiUrl + 'usuarios/fotoperfilpersona.do',
  uploadFotoPersona: environment.apiUrl + 'usuarios/uploadFotoPersona.do',

  consultaTallerPaginacion: environment.apiUrl + 'taller/consultarTallerPaginacion.do',
  consultaTallerAll: 'taller/consultarTallerAll',
  guardarTaller: environment.apiUrl + 'taller/guardaTaller.do',

  //Catalogo de Documentos
  consultarDocumentacionPaginacion: environment.apiUrl + 'documentos/consultarDocumentacionPaginacion.do',
  consultaGarantia: environment.apiUrl + 'documentos/consultaGarantia.do',
  consultaCredito: environment.apiUrl + 'documentos/consultaCredito.do',
  guardaActualizaDocumento: environment.apiUrl + 'documentos/guardaActualizaDocumento.do',
  ConsulXUpdateDocumento: environment.apiUrl + 'documentos/ConsulXUpdateDocumento.do',
  consultaDocumentosAll: 'documentos/consultaDocumentosAll.do',
  consultaDocumentoCredito: environment.apiUrl + 'documentos/consultaDocumentoCredito.do',
  consultaGarantias: environment.apiUrl + 'documentos/consultaGarantiasCredito.do',
  guardaRegistroDocumentos: environment.apiUrl + 'documentos/guardaRegistroDocumentos.do',
  CONSULTAR_DOCUMENTO_DESCRIPCION: environment.apiUrl + 'documentos/consultaDocumentosDescripcion.do',

  //Catalogo de Documentos Personas
  consultaCatalogoDocumentosPersonaPaginado: 'documentos_persona/consultaCatalogoDocumentosPersonaPaginado.do',
  guardaActualizaCatalogoDocumentosPersona: environment.apiUrl + 'documentos_persona/guardaActualizaDocumentoPersona.do',
  consultaRegistroDocumentosPersona: environment.apiUrl + 'documentos_persona/consultarDocumentosPersona.do',


  //Tipo de Personas
  consultarPersonasPaginacion: environment.apiUrl + 'consultarPersonasPaginacion.do',
  guardaActualizaPersona: environment.apiUrl + 'guardaActualizaPersona.do',
  consultaPersonadAll: 'consultaPersonadAll.do',

  //Periodicidad
  consultarPeriodicidadPaginacion: environment.apiUrl + 'consultarPeriodicidadPaginacion.do',
  guardaPeriodicidad: environment.apiUrl + 'guardaPeriodicidad.do',
  consultaPeriodicidadAll: 'consultarPeriodicidadaAll.do',

  //Poblacion
  CONSULTAR_POBLACION_BY_USUARIO_ACTIVO: environment.apiUrl + 'consultarPoblacionActivoByUsuario.do',
  CONSULTAR_POBLACION_BY_USUARIO: environment.apiUrl + 'consultarPoblacionByUsuario.do',
  CONSULTA_POBLACION_PAGINACION: 'consultarPoblacionPaginacion.do',
  GUARDA_ACTUALIZA_POBLACION: environment.apiUrl + 'guardaPoblacion.do',
  CONSULTA_POBLACION: environment.apiUrl + 'consultarPoblacion.do',
  CONSULTA_POBLACION_ACTIVO: environment.apiUrl + 'consultarPoblacionActivo.do',
  MOVER_CREDITO_POBLACION: environment.apiUrl + 'moverCreditoPoblacion.do',

  CONSULTA_USUARIO_GESTOR: 'consultarUsuarioGestor.do',
  CONSULTA_USUARIO_GESTOR_BY_USUARIO: 'consultarUsuarioGestorByIdUsuario.do',
  CONSULTA_USUARIO_POBLACION: environment.apiUrl + 'consultarUsuarioPoblacion.do',
  GUARDA_USUARIO_POBLACION: environment.apiUrl + 'guardarUsuarioPoblacion.do',
  DELETE_USUARIO_POBLACION: environment.apiUrl + 'eliminarrUsuarioPoblacion.do',

  //URL REPORTES JSREPORT
  GENERAR_REPORTE_PDF: environment.apiUrl + 'generarReportePDF.do',
  CONSULTAR_PDF_COTIZACION: environment.apiUrl + 'reportePDFCotizador.do',
  CONSULTAR_PDF_INVERSION: environment.apiUrl + 'reportePDFProyectoInversion.do',
  CONSULTAR_PDF_COTIZACION2: environment.apiUrl + 'reportePDFCotizador2.do',
  CONSULTAR_PDF_PAGARE: environment.apiUrl + 'reportePDFPagare.do',
  CONSULTAR_PDF_RECIBO: environment.apiUrl + 'reportePDFRecibo.do',
  CONSULTAR_PDF_CONTRATO: environment.apiUrl + 'reportePDFContrato.do',
  CONSULTAR_PDF_PLDFISICO: environment.apiUrl + 'reportePDFFisico.do',
  CONSULTAR_PDF_PLDMORAL: environment.apiUrl + 'reportePDFMoral.do',
  CONSULTAR_PDF_GARANTIASMUEBLES: environment.apiUrl + 'reportePDFGarantiasMuebles.do',
  CONSULTAR_PDF_GARANTIASINMUEBLES: environment.apiUrl + 'reportePDFGarantiasInmuebles.do',
  CONSULTAR_PDF_REPORTE_FONDEO: environment.apiUrl + 'reportePDFReporteFondeo.do',

  //Plazo de Creditos
  validarDuplicado: environment.apiUrl + 'plazo/validarDuplicado.do',
  guardaActualizaPlazo: environment.apiUrl + 'plazo/guardaActualizaPlazo.do',
  //Tipo de Garantia
  validarDuplicadoGarantia: environment.apiUrl + 'tiposGarantias/validarDuplicadoGarantia.do',
  consultaTipoGarantiaActivos: environment.apiUrl + 'tiposGarantias/consultaTipoGarantiaActivos.do',
  //Productos
  validarDuplicadoProducto: environment.apiUrl + "taller/validarDuplicadoProducto.do",

  //Historico de cotizaciones
  CONSULTA_COTIZACIONES: 'cotizacion/paginadorHistoricoCotizaciones',

  CREDITO_CONVERTIDO: environment.apiUrl + 'credito/convertirCotizacion',
  //creditos
  guardaAval: environment.apiUrl + 'guardaAval.do',
  guardaCoacreditado: environment.apiUrl + 'guardaCoacreditado.do',
  consultaAvales: environment.apiUrl + 'avalesCredito/consultaAvalesCredito.do',
  consultaPagare: environment.apiUrl + 'credito/consultaPagareCredito.do',
  buscarPagare: "pagare/buscarPagareCondonacion",

  //Consulta de Créditos
  CONSULTA_CREDITOS_ACTIVO: 'credito/paginadorCreditosActivosWeb',
  CONSULTA_CREDITOS: 'credito/paginadorCreditosWeb',
  CONSULTA_CREDITOS_SALDOS: 'creditoConsultaSaldos/paginadorCreditosConsultaSaldosWeb',
  CONSULTA_CARTERA_VENCIDA: 'creditoConsultaSaldos/paginadorCreditosConsultaCarteraVencida',
  CONSULTA_CREDITOS_CANTIDATOS_A_RENOVACION: "creditoConsultaSaldos/consultaCreditosCantidatosARenovacion",
  CONSULTA_PAGARES_VENCIDOS: "creditoConsultaSaldos/consultarPagaresVencidos.do",
  consultaCorreoJuridico: environment.apiUrl + 'credito/consultaCorreoJuridico.do',
  BUSCAR_MOVIMIENTO: "creditoConsultaSaldos/buscarMovimientoById",

  //Inversion
  consultaInversiones: environment.apiUrl + 'consultaInversion.do',
  consultaidInversion: environment.apiUrl + 'consultaidInversion.do',
  guardaProyeccion: environment.apiUrl + 'guardaInversionProyeccion.do',
  guardaInversion: environment.apiUrl + 'guardaInversion',
  obtenerInversionPorID: environment.apiUrl + 'obtenerInversionPorID.do',
  documentoInversion: environment.apiUrl + 'documentoInversion',
  guardaDocumentoInversion: environment.apiUrl + 'guardaDocumentoInversion',
  CONSULTA_INVERSIONES: environment.apiUrl + 'consultaInversiones',
  CONSULTA_INVERSIONES_FILTRO: environment.apiUrl + 'consultaInversionesFiltro',

  //Consulta de notas
  CONSULTA_NOTAS_CREDITO: 'notasCredito/paginadorNotas',
  actualizacionFondeo: environment.apiUrl + 'credito/actualizacionFondeo.do',
  guardarMovimientoCredito: environment.apiUrl + 'credito/guardarMovimientoCredito.do',
  obtenerPldMoral: environment.apiUrl + 'pldMoral/obtenerPldMoral.do',

  //Reestructura
  guardarReestructura: environment.apiUrl + 'credito/guardarReestructura.do',
  CONSULTAR_DETALLE_REESTRUCTURA: environment.apiUrl + 'renovacion/detalleReestructura',
  CONSULTAR_REESTRUCTURAS: environment.apiUrl + 'credito/paginadorConsultarReestructuras.do',
  actualizarReestructura: environment.apiUrl + 'credito/actualizarReestructura.do',
  consultarReestructurasPagares: environment.apiUrl + 'credito/consultaReestructuraPagares.do',

  //ConvenioEmbargo
  CONVENIO_EMBARGO: "convenio_embargo",
  SOLICITAR_CONVENIO: "convenio_embargo/realizarSolicitud",
  CONSULTAR_CONVENIO_EMBARGO_PAGINADO: "convenio_embargo/consultaConvenioEmbargoPaginado.do",
  CONSULTAR_CONVENIO_EMBARGO_EXIST: "convenio_embargo/convenioEmbargoExist",
  CONSULTAR_ESTATUS_CONVENIO: environment.apiUrl + "estatusConvenio/consultaEstatusConvenio.do",
  EMBARGAR: "convenio_embargo/realizarEmbargo",

  //Reenovacion
  CONSULTAR_RENOVACION: environment.apiUrl + 'renovacion/renovaciones',
  CONSULTAR_DETALLE_RENOVACION: environment.apiUrl + 'renovacion/detallerenovacion',
  actualizarRenovacion: environment.apiUrl + 'renovacion/actualizarRenovacion.do',

  //Facturas
  consultarFacturasPaginado: environment.apiUrl + 'credito/paginadorConsultarFacturas.do',
  consultarNotasCargoPaginado: environment.apiUrl + 'credito/paginadorConsultarNotasCargo.do',

  //Estados de cuenta
  consultarEstadosDeCuentaPaginado: environment.apiUrl + 'credito/paginadorConsultarEstadosDeCuenta.do',

  //Cancelación de pagos
  consultarPagosRealizadosPaginado: environment.apiUrl + 'cancelacionPago/paginadorConsultaMovimientosRealizados.do',
  guardarSolicitudCancelacion: environment.apiUrl + 'cancelacionPago/guardarCancelacionPago.do',
  consultarSolicitudesCancelacion: environment.apiUrl + 'cancelacionPago/consultarSolicitudesCancelacion.do',
  actualizarSolicitudCancelacion: environment.apiUrl + 'cancelacionPago/actualizarSolicitudCancelacion.do',

  //Condonacion de moratorios
  consultarPagaresPaginados: environment.apiUrl + 'credito/consultarPagaresPaginados.do',
  guardarSolicitudCondonacion: environment.apiUrl + 'credito/guardarSolicitudCondonacion.do',
  consultarSolicitudesCondonacionMoratorios: environment.apiUrl + 'credito/consultarSolicitudesCondonacion.do',
  actualizarSolicitudCondonacion: environment.apiUrl + 'credito/actualizarSolicitudCondonacion.do',

  obtenerPldFisico: environment.apiUrl + 'pldFisico/obtenerPldFisico.do',
  obtenerCuestionarioMuebles: environment.apiUrl + 'garantiasMuebles/obtenerCuestionarioMuebles.do',
  actualizaFisico: environment.apiUrl + 'pldFisico/actualizaPldFisico.do',
  obtenerCuestionarioInmuebles: environment.apiUrl + 'garantiasInmuebles/obtenerCuestionarioInmuebles.do',

  //CONSULTA 5 REPORTES
  CONSULTA_REPORTE_EXIGIBILIDAD: 'consultaReporteExigibilidad.do',
  CONSULTA_REPORTE_PRESTAMO_ESTATUS: 'consultaReportePrestamoEstatus.do',
  CONSULTA_REPORTE_ESTADO_CARTERA: 'consultaReporteEstadoCartera.do',
  CONSULTA_REPORTE_COLOCACION: 'consultaReporteColocacion.do',
  CONSULTA_REPORTE_DESGLOCE_COBRANZA: 'consultaReporteDesgloceCobranza.do',
  CONSULTA_REPORTE_DIARIO_COBRANZA: 'consultaReporteDiarioCobranza.do',

  //PLD
  consultarArchivoPld: environment.apiUrl + 'consultaInfByPld.do',
  consultarArchivoPldxml: environment.apiUrl + 'consultaInfByPldAll.do',
  CONSULTA_INFCREDITOBYPLD: environment.apiUrl + 'consultaInfCreditoByPld.do',
  eliminarPld: environment.apiUrl + 'eliminarPld.do',

  actualizacionPersonaGarantias: environment.apiUrl + 'documentos/actualizacionPersonaGarantias.do',
  consultaPersonaGarantia: environment.apiUrl + 'documentos/consultaPersonaGarantia.do',


  //GastosCobranza
  consultaGastosCobranzaAll: 'gastosCobranza/consultaGastosCobranzaAll.do',
  guardarMovimientoCobranza: environment.apiUrl + 'gastosCobranza/guardarMovimientoCobranza.do',
  insertarDatosCotizador: environment.apiUrl + 'cotizacionCredito',

  actualizarCreditoPersona: environment.apiUrl + 'credito/actualizarCreditoPersona.do',
  NOTIFICACION_WHATSAPP: 'notificacionWhatsapp/enviar',

  //Consulta de carteras
  BUSCAR_CARTERA_POR_ID: 'cartera/buscarCarteraPorId',
  BUSCAR_CARTERA_CREDITOS_FILTRO: 'cartera/cosultarListaDeCarteras',
  RESUMEN_CARTERAS_CREDITOS_ACTIVO: 'cartera/resumenDeCarteras',
  TRASPASO_CARTERAS_CREDITOS: 'cartera/traspasoDeCarteras',

};
